/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
		constructor() {
			super();
			this.pageHeight = window.innerHeight;
		}

		connectedCallback() {
			this.addEventListener('click', this.onClick);
			this.addEventListener('touchstart', this.onClick, {
				passive: true
			});
			this.scrollTicking = false;
			window.addEventListener('scroll', this.checkVisible.bind(this), {
				passive: true
			});
		}

		checkVisible(event) {
			if (this.scrollTicking) return;
			this.scrollTicking = true;
			window.requestAnimationFrame(() => {
				this.scrollTicking = false;
				let y = window.scrollY;
				if (y > this.pageHeight) {
					this.classList.add('back-to-top--active');
				} else {
					this.classList.remove('back-to-top--active');
				}
			});
		}

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}
	}
	customElements.define('back-to-top', BackToTop);
}
